import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

export default function ConfirmDialog(props: {
  handleCloseDialog: any;
  handleConfirm: any;
  openDialog: any;
  name: string;
  record?: string;
}) {
  const { handleCloseDialog, handleConfirm, openDialog, name, record } = props;

  return (
    <Dialog
      sx={{
        width: { xs: "23em", sm: "27em", md: "30em", xl: "100%" },
        margin: "auto",
      }}
      open={openDialog}
      onClose={handleCloseDialog}
      fullWidth
    >
      <DialogTitle variant={"h3"}>Delete {name}</DialogTitle>
      <DialogContent sx={{ pb: "2em" }}>
        <DialogContentText variant={"h5"}>Are you sure you want to delete the {name} <span style={{ color: "black"}}>{record}?</span></DialogContentText>        
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleConfirm} autoFocus variant="outlined" color="error">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
